let footerLoading = false;
let footerCallbacks = [];

function loadFooter(callback) {
    if ($('footer#footer').length) {
        callback();
        return;
    }

    footerCallbacks.push(callback);
    if (footerLoading) return;

    footerLoading = true;

    function footerDone() {
        footerLoading = false;
        const callbacks = footerCallbacks;
        footerCallbacks = [];
        callbacks.forEach(function (cb) {
            cb();
        });
    }

    if (sessionStorage.loadedFooter) {
        $('.overall-wrapper').append('<footer id="footer">' + sessionStorage.loadedFooter + '</footer>');
        footerDone();
    } else {
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: '/',
            success: function (e) {
                var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find('footer#footer').html();
                if (t) {
                    $('.overall-wrapper').append('<footer id="footer">' + t + '</footer>');
                    sessionStorage.loadedFooter = t;
                }
                footerDone();
            },
            error: footerDone
        });
    }
}

const groupId = Number(getShoptetDataLayer('customer')?.groupId);
if (VOGroup.includes(groupId)) {
    document.body.classList.add('vo-customer');
}

$('.breadcrumbs span#navigation-first span[itemprop="name"]').attr('itemprop', 'incomputer.cz');
$('.siteCookies__links').append($('.siteCookies__buttonWrap button'));

$(document).on('cbox_closed', function () {
    $('#colorbox #cboxContent').removeAttr('style');
});


function checkHeight() {
    const $el = $(".cart-widget-products");
    $el.toggleClass("scrollbar", $el.outerHeight() > 359);
}


function checkCartState() {
    const hasInCart = $('i[data-testid="headerCartCount"]').length && parseInt($('i[data-testid="headerCartCount"]').text()) > 0;
    if (hasInCart < 1) {
        $("#cart-widget").addClass("empty").removeClass('loader-wrapper');

        if (!$('a.cart-count i[data-testid="headerCartCount"]').length) {
            $('a[data-target="cart"]').append('<i data-testid="headerCartCount">0</i>')
        }
        return;
    }
    $("#cart-widget").removeClass("empty");
    $('a[data-target="cart"]').addClass('full');

}



$(document).on('click', function (e) {
    const $body = $('body');

    if (
        $body.hasClass('user-action-visible') &&
        $body.hasClass('login-window-visible') &&
        !$(e.target).closest('.login-widget, .customLoginPopup').length
    ) {
        $body.removeClass('user-action-visible login-window-visible');
    }
});


function initCustomerLoginScrollbar() {
    var $customerLogin = $('#customerLogin');

    if (!$customerLogin.length) {
        return;
    }

    var $loginWidgetInner = $customerLogin.closest('.popup-widget-inner');

    if (!$loginWidgetInner.length) {
        return;
    }

    var $scrollbar = $loginWidgetInner.find('.customerLoginScrollbar');

    if (!$scrollbar.length) {
        $loginWidgetInner.append(`
            <div class="customerLoginScrollbar">
                <div class="customerLoginScrollbarThumb"></div>
            </div>
        `);

        $scrollbar = $loginWidgetInner.find('.customerLoginScrollbar');
    }

    var $thumb = $scrollbar.find('.customerLoginScrollbarThumb');

    function updateCustomerLoginScrollbar() {
        var el = $customerLogin[0];

        if (!el) {
            return;
        }

        var scrollHeight = el.scrollHeight;
        var clientHeight = el.clientHeight;
        var scrollTop = el.scrollTop;
        var trackHeight = $scrollbar.outerHeight();

        $scrollbar.show();

        if (!scrollHeight || !clientHeight || !trackHeight) {
            $thumb.css({
                height: '60%',
                transform: 'translateY(0)'
            });
            return;
        }

        var thumbHeight = Math.max(32, clientHeight / scrollHeight * trackHeight);
        var maxThumbTop = trackHeight - thumbHeight;
        var maxScrollTop = scrollHeight - clientHeight;
        var thumbTop = maxScrollTop > 0 ? scrollTop / maxScrollTop * maxThumbTop : 0;

        $thumb.css({
           // height: thumbHeight + 'px',
            height: '60%',
            transform: 'translateY(' + thumbTop + 'px)'
        });
    }

    $customerLogin
        .off('scroll.customerLoginScrollbar')
        .on('scroll.customerLoginScrollbar', updateCustomerLoginScrollbar);

    $(window)
        .off('resize.customerLoginScrollbar')
        .on('resize.customerLoginScrollbar', updateCustomerLoginScrollbar);

    updateCustomerLoginScrollbar();
    requestAnimationFrame(updateCustomerLoginScrollbar);

    setTimeout(updateCustomerLoginScrollbar, 50);
    setTimeout(updateCustomerLoginScrollbar, 150);
    setTimeout(updateCustomerLoginScrollbar, 300);
    setTimeout(updateCustomerLoginScrollbar, 700);
}
function toggleMobileCustom() {
  if (window.innerWidth < 992) {
    $("body").addClass("mobile");
  } else {
    $("body").removeClass("mobile");
  }
}

toggleMobileCustom();
$(window).on("resize", toggleMobileCustom);

$(document).ready(function () {
    initCustomerLoginScrollbar();
});

document.addEventListener('ShoptetDOMContentLoaded', function () {
    initCustomerLoginScrollbar();
});

document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    initCustomerLoginScrollbar();
});



function getUsps(domPlace) {
    if ($(domPlace).find('.uspWrap').length) {
        return;
    }

    var cached = sessionStorage.usps;
    if (cached) {
        $(domPlace).append(cached);
        return;
    }
    $.ajax({
        type: "GET",
        dataType: "html",
        timeout: 10000,
        cache: true,
        url: "/",
        success: function (e) {
            var doc = shoptet.common.createDocumentFromString(e);
            var uspsHtml = $(doc).find(".uspWrap").prop('outerHTML');

            if (uspsHtml && !$(domPlace).find('.uspWrap').length) {
                sessionStorage.usps = uspsHtml;
                $(domPlace).append(uspsHtml);
            }
        }
    });
}

function initRatingsFakeScrollbar() {
    var $list = $('.tab-content #ratingsList');

    if (!$list.length) return;

    // už inicializováno
    if ($list.parent().hasClass('ratingsScrollWrap')) {
        updateRatingsFakeScrollbar();
        return;
    }

    // obalíme #ratingsList a vložíme fake scrollbar
    $list.wrap('<div class="ratingsScrollWrap is-top"></div>');

    var $wrap = $list.parent();

    $wrap.append(
        '<div class="ratingsFakeScrollbar">' +
            '<div class="ratingsFakeScrollbarThumb"></div>' +
        '</div>'
    );

    $list.on('scroll.ratingsFakeScrollbar', function () {
        updateRatingsFakeScrollbar();
    });

    $(window).on('resize.ratingsFakeScrollbar', function () {
        updateRatingsFakeScrollbar();
    });

    initRatingsFakeScrollbarDrag();

    updateRatingsFakeScrollbar();

    setTimeout(updateRatingsFakeScrollbar, 300);
}

function updateRatingsFakeScrollbar() {
    var $list = $('.tab-content #ratingsList');

    if (!$list.length) return;

    var el = $list[0];
    var $wrap = $list.parent('.ratingsScrollWrap');
    var $bar = $wrap.find('.ratingsFakeScrollbar');
    var $thumb = $wrap.find('.ratingsFakeScrollbarThumb');

    if (!$wrap.length || !$bar.length || !$thumb.length) return;

    var scrollTop = el.scrollTop;
    var scrollHeight = el.scrollHeight;
    var clientHeight = el.clientHeight;
    var maxScrollTop = scrollHeight - clientHeight;

    var isScrollable = scrollHeight > clientHeight + 1;
    var isTop = scrollTop <= 0;
    var isBottom = scrollTop >= maxScrollTop - 1;

    $wrap.toggleClass('has-scroll', isScrollable);
    $wrap.toggleClass('is-top', isTop);
    $wrap.toggleClass('is-bottom', isBottom);

    $list.toggleClass('is-top', isTop);
    $list.toggleClass('is-bottom', isBottom);
    $list.toggleClass('has-scroll', isScrollable);

    if (!isScrollable) {
        $thumb.css({
            height: '0px',
            transform: 'translateY(0px)'
        });

        return;
    }

    var trackHeight = $bar.height();

    var thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, 40);
    var maxThumbMove = trackHeight - thumbHeight;

    var thumbTop = maxScrollTop > 0
        ? (scrollTop / maxScrollTop) * maxThumbMove
        : 0;

    $thumb.css({
        height: thumbHeight + 'px',
        transform: 'translateY(' + thumbTop + 'px)'
    });

    // uložíme si hodnoty pro drag
    $bar.data('trackHeight', trackHeight);
    $thumb.data('thumbHeight', thumbHeight);
}

function initRatingsFakeScrollbarDrag() {
    var $list = $('.tab-content #ratingsList');

    if (!$list.length) return;

    var $wrap = $list.parent('.ratingsScrollWrap');
    var $bar = $wrap.find('.ratingsFakeScrollbar');
    var $thumb = $wrap.find('.ratingsFakeScrollbarThumb');

    if (!$bar.length || !$thumb.length) return;

    var isDragging = false;
    var startY = 0;
    var startScrollTop = 0;

    // aby se eventy neduplikovaly
    $thumb.off('mousedown.ratingsFakeScrollbarDrag');
    $bar.off('mousedown.ratingsFakeScrollbarTrack');
    $(document).off('mousemove.ratingsFakeScrollbarDrag mouseup.ratingsFakeScrollbarDrag');

    // chytneš přímo palec scrollbar-u
    $thumb.on('mousedown.ratingsFakeScrollbarDrag', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var el = $list[0];

        isDragging = true;
        startY = e.pageY;
        startScrollTop = el.scrollTop;

        $thumb.addClass('is-dragging');
        $('body').addClass('ratings-scrollbar-dragging');
    });

    // kliknutí do dráhy scrollbar-u posune obsah na dané místo
    $bar.on('mousedown.ratingsFakeScrollbarTrack', function (e) {
        if ($(e.target).is('.ratingsFakeScrollbarThumb')) return;

        e.preventDefault();

        var el = $list[0];

        var barOffsetTop = $bar.offset().top;
        var clickY = e.pageY - barOffsetTop;

        var scrollHeight = el.scrollHeight;
        var clientHeight = el.clientHeight;
        var maxScrollTop = scrollHeight - clientHeight;

        var trackHeight = $bar.height();
        var thumbHeight = $thumb.outerHeight();

        var targetThumbTop = clickY - (thumbHeight / 2);
        var maxThumbMove = trackHeight - thumbHeight;

        targetThumbTop = Math.max(0, Math.min(targetThumbTop, maxThumbMove));

        var targetScrollTop = maxThumbMove > 0
            ? (targetThumbTop / maxThumbMove) * maxScrollTop
            : 0;

        el.scrollTop = targetScrollTop;

        updateRatingsFakeScrollbar();
    });

    $(document).on('mousemove.ratingsFakeScrollbarDrag', function (e) {
        if (!isDragging) return;

        e.preventDefault();

        var el = $list[0];

        var scrollHeight = el.scrollHeight;
        var clientHeight = el.clientHeight;
        var maxScrollTop = scrollHeight - clientHeight;

        var trackHeight = $bar.height();
        var thumbHeight = $thumb.outerHeight();
        var maxThumbMove = trackHeight - thumbHeight;

        if (maxThumbMove <= 0 || maxScrollTop <= 0) return;

        var deltaY = e.pageY - startY;
        var scrollRatio = maxScrollTop / maxThumbMove;

        el.scrollTop = startScrollTop + (deltaY * scrollRatio);

        updateRatingsFakeScrollbar();
    });

    $(document).on('mouseup.ratingsFakeScrollbarDrag', function () {
        if (!isDragging) return;

        isDragging = false;

        $thumb.removeClass('is-dragging');
        $('body').removeClass('ratings-scrollbar-dragging');
    });
}

$(function () {
    initRatingsFakeScrollbar();
});

$(document).on('ShoptetDOMPageContentLoaded ShoptetDOMPageMoreProductsLoaded ShoptetVariantAvailable ShoptetVariantUnavailable', function () {
    initRatingsFakeScrollbar();
});

function hideAppendixForWarrantyGroup() {
    var priceListId = parseInt(getShoptetDataLayer('customer')?.priceListId || 0, 10);
    if (!warrantyMap.hasOwnProperty(priceListId)) {
        return;
    }

    $('.product .product-appendix').hide();
    $('.id--17 .product-appendix').hide();
    $('.id--16 .product-appendix').hide();
    $('.id--15 .product-appendix').hide();
    if ($('body').hasClass('type-detail')) {
        $('.p-info-wrapper .p-gifts-wrapper').hide();
    }
}

$(function () {
    hideAppendixForWarrantyGroup();
});

$(document).on('ShoptetDOMPageContentLoaded ShoptetDOMPageMoreProductsLoaded ShoptetVariantAvailable ShoptetVariantUnavailable', function () {
    hideAppendixForWarrantyGroup();
});